import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { OutgoingCredentialsModalEntrypointProps } from './OutgoingCredentialsModal.entrypoint.types.tsx';

type OutgoingCredentialsModalEntryPointComponent = EntryPointComponent<
	{},
	{},
	OutgoingCredentialsModalEntrypointProps,
	{}
>;

export const outgoingCredentialsModalEntryPoint: EntryPoint<
	OutgoingCredentialsModalEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<OutgoingCredentialsModalEntryPointComponent>(
		/* webpackChunkName: "applinks-outgoing-credentials-modal" */ './OutgoingCredentialsModal.tsx',
	),
	getPreloadProps: () => ({}),
});
